import qs from 'qs';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import '@/common/plugins';
import '@/icons';
import '@/styles/main.scss';
import * as widgets from './widgets';
import { eventBus } from './eventBus';
import * as metrixEvents from '../metrix/events';
import { http } from '@/http';
import { AuthParams } from '@/widgets/AuthWidget/types';
import { ModalData } from '@/widgets/FeedbackWidget/types';
import { ModalDataBaner } from '@/widgets/SeeBanerWidget/types';

const configurable = process.env.NODE_ENV === 'development';

Object.defineProperties(window, {
    $feedbackWidget: {
        value: Object.freeze({
            show(modalData?: ModalData) {
                widgets.feedbackWidget.show(modalData);
            },
            hide() {
                widgets.feedbackWidget.close();
            },
        }),
        configurable,
    },
    $seeBanerWidget: {
        value: Object.freeze({
            show(modalDataBaner?: ModalDataBaner) {
                widgets.seeBanerWidget.show(modalDataBaner);
            },
            hide() {
                widgets.seeBanerWidget.close();
            },
        }),
        configurable,
    },
    $favorites: {
        value: widgets.favorites,
        configurable,
    },
    $authWidget: {
        value: Object.freeze({
            withParams(authParams: AuthParams) {
                return widgets.authWidget.withParams(authParams);
            },
            goToLK() {
                widgets.authWidget.goToLK();
            },
            hide() {
                widgets.authWidget.close();
            },
        }),
        configurable,
    },

    $eventBus: {
        value: eventBus,
        configurable,
    },

    $metrixEvents: {
        value: metrixEvents,
        configurable,
    },

    $qs: {
        value: qs,
        configurable,
    },

    $http: {
        value: http,
        configurable,
    },
});

lazySizes.cfg.init = false;
/** load or DOMContentLoaded */
window.addEventListener('load', function() {
    lazySizes.init();
});

[...document.querySelectorAll('[data-action="go-to-lk"]')].forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault();
        widgets.authWidget.goToLK();
    });
});
